import { EndOfJourneyScanItemManualForm } from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEndOfJourneyScanItemManualForm(itemId: number, enrollmentId: number) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API['end-of-journey-scans'].getItemManualForm.url, { id: itemId }),
        { enrollmentId }
      )
    )
    .get<EndOfJourneyScanItemManualForm>()
}
